import React from "react";
import PropTypes from "prop-types";

// styles
import * as styles from "./StepCard.module.css";

const propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      stepNumber: PropTypes.string.isRequired,
      stepIcon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      stepIconAlt: PropTypes.string,
      numberIconAlt: PropTypes.string,
    })
  ).isRequired,
};

const StepCard = ({ cards }) => {
  return (
    <div className={styles.cardsWrapper}>
      <div className={styles.cardsGrid}>
        {cards.map((card, index) => (
          <div key={index} className={styles.card}>
            {/* Background Gradient Circle */}
            <div className={styles.gradientCircle}></div>

            {/* Step Number */}
            <div className={styles.stepNumber}>
              <img
                src={card.stepNumber}
                alt={card.numberIconAlt || `Step ${index + 1}`}
                className={styles.numberImage}
              />
            </div>

            {/* Step Icon */}
            <div className={styles.stepIcon}>
              <img
                src={card.stepIcon}
                alt={card.stepIconAlt || card.title}
                className={styles.iconImage}
              />
            </div>

            {/* Title */}
            <h3 className={styles.cardTitle}>{card.title}</h3>
          </div>
        ))}
      </div>
    </div>
  );
};

StepCard.propTypes = propTypes;

export default StepCard;
